import { render, staticRenderFns } from "./3_m_magazine.vue?vue&type=template&id=bcfc83ca&scoped=true&"
import script from "./3_m_magazine.vue?vue&type=script&lang=js&"
export * from "./3_m_magazine.vue?vue&type=script&lang=js&"
import style0 from "./3_m_magazine.vue?vue&type=style&index=0&id=bcfc83ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfc83ca",
  null
  
)

export default component.exports